export default "__VITE_ASSET__2ad3b1b1__"